export enum UnitOfMeasurementEnum {
	UNIT = 'UNIT',
	HOUR = 'HOUR',
	METER = 'METER',
	SQUARE_METERS = 'SQUARE_METERS',
	CUBIC_METERS = 'CUBIC_METERS',
}
